var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "LinkedIn") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile_Overview1_V2",
    transform: "translate(-284.000000, -334.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Course-Details",
    transform: "translate(0.000000, 37.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(0.000000, 33.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "social",
    transform: "translate(186.000000, 264.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "linkedin-logo",
    transform: "translate(98.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9759137,9.96740008 L16.9759137,16.2435038 L13.3374257,16.2435038 L13.3374257,10.3877357 C13.3374257,8.91671897 12.8111577,7.91280761 11.4941456,7.91280761 C10.488774,7.91280761 9.89047657,8.5893703 9.62726361,9.24383084 C9.53127712,9.47779792 9.50657007,9.80344946 9.50657007,10.130956 L9.50657007,16.2435038 L5.86685859,16.2435038 C5.86685859,16.2435038 5.91587801,6.32575461 5.86685859,5.29820184 L9.50621486,5.29820184 L9.50621486,6.84965458 C9.49883432,6.86125821 9.48924356,6.8737696 9.48229717,6.88501802 L9.50621486,6.88501802 L9.50621486,6.84965458 C9.98973892,6.10493042 10.8532621,5.04106697 12.7860954,5.04106697 C15.1807453,5.0410275 16.9759137,6.60542579 16.9759137,9.96740008 Z M2.05956543,0.0220232165 C0.814424863,0.0220232165 0,0.838737241 0,1.91274401 C0,2.96334617 0.790862389,3.80484618 2.01125644,3.80484618 L2.03556881,3.80484618 C3.3048244,3.80484618 4.094187,2.96350405 4.094187,1.91274401 C4.07026931,0.838737241 3.3048244,0.0220232165 2.05956543,0.0220232165 Z M0.216166948,16.2435038 L3.85449705,16.2435038 L3.85449705,5.29820184 L0.216166948,5.29820184 L0.216166948,16.2435038 Z",
    id: "LinkedIn"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.5a79771e5fb14c03a833d80bebb3810b.svg";
export { ForwardRef as ReactComponent };